import React, { useEffect } from 'react';
import vtkImageSlice from '@kitware/vtk.js/Rendering/Core/ImageSlice';
import {
  updateCPRAngleAndPath,
  updateRenderWindow,
} from '../Renderers/vtkManagers';
import type { CPRContext } from '../Renderers/vtkManagers';

export function useCprAnglePathRefresh({
  context,
  analysisType,
  disabled = false,
}: {
  context: React.MutableRefObject<CPRContext | null>;
  analysisType: string;
  disabled?: boolean;
}) {
  useEffect(() => {
    if (disabled) return;
    if (!context.current) return;
    const { actorIds } = context.current;
    const paintActor = actorIds['CPRPaintActor'] as vtkImageSlice;

    if (!paintActor) return;

    if (
      analysisType === 'plaque' ||
      analysisType === 'fai' ||
      analysisType === 'aorticValveCalcium' ||
      analysisType === 'tavi'
    ) {
      updateCPRAngleAndPath(context, context.current.angle);
      updateRenderWindow(context);
    }
  }, [context, context.current?.actorIds['CPRPaintActor'], analysisType, disabled]);
}
